import * as Yup from "yup";

import { BillingRunStatus } from "constants/billingRuns";

export const ValidationSchema = Yup.object().shape({
  billingSettingsId: Yup.string().required("Required!"),
  exportedAtDateTime: Yup.date().nullable(),
  livestockSaleIds: Yup.array()
    .of(Yup.number())
    .min(1, "Required!")
    .required("Required!"),
  name: Yup.string().required("Required!"),
  ruleBookId: Yup.string().nullable(),
  buyerPaysVendor: Yup.boolean(),
  status: Yup.string()
    .oneOf(Object.values(BillingRunStatus))
    .required("Required!"),
});
